
















































































































import { Component, Vue } from "vue-property-decorator";
import { skdu } from "@/config/host.config";

import StandartModal from "@/components/app/standart-modal.vue";

interface ISkduHealth {
  status: string;
  healthy: boolean;
  serverUrl: string;
  reconnectAttempt: number;
  isConnecting: boolean;
  autoReconnect: boolean;
  nextReconnect: string;
  heartbeat: { enabled: boolean; pingIntervalMs: number };
}

@Component({
  name: "skdu-config-settings",
  components: { StandartModal },
})
class SkduConfigSettings extends Vue {
  loading = false;
  healthLoading = false;
  saving = false;
  serverUrl = "";
  health: ISkduHealth | null = null;
  newUrl = "";

  get connected(): boolean {
    return !!this.health?.healthy;
  }

  get connectionBadge(): { variant: string; text: string } {
    if (!this.health)
      return {
        variant: "secondary",
        text: String(this.$i18n.t("Settings.skdu.noData")),
      };
    return this.connected
      ? {
          variant: "success",
          text: String(this.$i18n.t("Settings.skdu.connected")),
        }
      : {
          variant: "danger",
          text: String(this.$i18n.t("Settings.skdu.disconnected")),
        };
  }

  get urlState(): boolean | null {
    if (!this.newUrl) return null;
    return /^wss?:\/\/.+/i.test(this.newUrl);
  }

  async onShow(): Promise<void> {
    this.loading = true;
    await this.refresh();
    this.loading = false;
  }

  async refresh(): Promise<void> {
    this.healthLoading = true;
    await Promise.all([this.fetchServerUrl(), this.fetchHealth()]);
    this.healthLoading = false;
  }

  async fetchServerUrl(): Promise<void> {
    try {
      const res = await this.$axios.get(skdu.serverUrl);
      if (res.status === 200 && res.data?.success) {
        this.serverUrl = res.data.data?.serverUrl || "";
        this.newUrl = this.serverUrl;
      }
    } catch (error) {
      this.serverUrl = "";
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("Settings.skdu.loadError")),
        type: "error",
      });
    }
  }

  async fetchHealth(): Promise<void> {
    try {
      const res = await this.$axios.get(skdu.health);
      if (res.status === 200 && res.data?.success) {
        this.health = res.data.data;
      }
    } catch (error) {
      this.health = null;
    }
  }

  async onSubmit(event: HTMLFormElement): Promise<void> {
    event.preventDefault();
    if (!this.newUrl || this.urlState === false) return;
    this.saving = true;
    try {
      const res = await this.$axios.put(skdu.serverUrl, { url: this.newUrl });
      if (res.status === 200 && res.data?.success) {
        if (res.data.data?.connected === false) {
          this.$notify({
            group: "global",
            text: String(res.data.message),
            type: "warn",
          });
        } else {
          this.$notify({
            group: "global",
            text: String(this.$i18n.t("error.200")),
          });
        }
        this.refresh();
      }
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(
          (error as { response?: { data?: { error?: string } } })?.response
            ?.data?.error || this.$i18n.t("Settings.skdu.saveError")
        ),
        type: "error",
      });
    } finally {
      this.saving = false;
    }
  }
}
export default SkduConfigSettings;
